# TODO: While this is generic functionality, at the moment it's only being used in the Post Later and Referral modals, so it's here in the jobs directory.  Eventually we'll want to move this into a higher-level, all-generic directory. 

$(->

  # 'DO NOT SHOW ME THIS AGAIN' CHECKBOXES IN POST LATER & REFERRAL OVERLAYS

  $(document).on 'click', '.updates-user-setting', (ev)->
    if $(this).data('disabled')?
      val = $(this).data('disabled')
    else
      val = 0
    if $(this).is(':checked')
      if $(this).data('enabled')?
        val = $(this).data('enabled')
      else
        val = 1
    data = {}
    data[$(this).data('key')] = val
    $.post '/manage/users/settings', data

)
